import { Anchor, Stack, Text, Tooltip } from '@mantine/core';
import { ReactElement } from 'react';
import { Link } from 'react-router';
import dayjs from 'dayjs';

export function PatientCell({
  patientId,
  patientName,
  patientDOB,
}: {
  patientId: string;
  patientName: string | null;
  patientDOB: string | null;
}): ReactElement {
  return (
    <Stack gap={0}>
      <Anchor component={Link} to={`/Patient/${patientId}/timeline`} size="sm">
        {patientName ?? patientId}
      </Anchor>
      {patientDOB && (
        <Text size="xs" c="dimmed">
          DOB {dayjs(patientDOB).format('M/D/YYYY')}
        </Text>
      )}
    </Stack>
  );
}

/** Procedure label with the raw appointment-type code on hover, so a mislabelled booking is visible. */
export function ProcedureCell({
  typeCode,
  typeDisplay,
  dateLabel,
  locationName,
}: {
  typeCode: string;
  typeDisplay: string;
  dateLabel: string | null;
  locationName: string | null;
}): ReactElement {
  return (
    <Stack gap={0}>
      <Tooltip label={typeCode}>
        <Text size="sm">{typeDisplay}</Text>
      </Tooltip>
      <Text size="xs" c="dimmed">
        {dateLabel ?? '—'} · {locationName ?? '—'}
      </Text>
    </Stack>
  );
}
